<template>
  <sources
    :crfqLineId="reqLineId"
    :gridId="gridId"/>
</template>

<script>
/*import { mapGetters } from 'vuex';*/

import { GRID_ID } from '@/shared/constants';
import Sources from '@/shared/components/Sources';

export default {
  props: {
    reqLineId: {
      type: [Number, String],
      default: 0,
    },
  },
  /*computed: {
    ...mapGetters('requirements', [
      'selectedRequirement',
    ]),
    ...mapGetters('requirementAdd', [
      'currentPart',
    ]),
  },*/
  data: () => ({
    gridId: GRID_ID.REQUIREMENT_FOUND_PARTS,
  }),
  components: {
    Sources,
  },
};
</script>
